"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _Attachment = require("./Attachment");

var _Attachment2 = _interopRequireDefault(_Attachment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Phrase = function Phrase(api, data) {
  (0, _classCallCheck3.default)(this, Phrase);

  _initialiseProps.call(this);

  Object.assign(this, (0, _extends3.default)({ api: api }, data));
};

Phrase._namespace = "phrases";

Phrase.getPhrases = function (api) {
  return api.getCollection(Phrase, "phrases?limit=300&cursor=", {}, false);
};

Phrase.getPhrasesChunk = function (api, chunk) {
  return new Promise(function (resolve, reject) {
    api.getCollection(Phrase, "phrases/" + chunk.join()).then(function (res) {
      resolve(res);
    });
  });
};

Phrase.getPhrase = function (api, id) {
  return api.getObject(Phrase, "phrases", id);
};

Phrase.addNewPhrase = function (api, data) {
  return api.postObject(Phrase, "phrases", data);
};

Phrase.updatePhrase = function (api, id, data) {
  return api.putObject(Phrase, "phrases", id, data);
};

Phrase.deletePhrase = function (api, id) {
  return api.deleteObject(Phrase, "phrases", id);
};

var _initialiseProps = function _initialiseProps() {
  var _this = this;

  this.recordedTranslations = {};

  this.setRecordedTranslation = function (_ref) {
    var language = _ref.language,
        blobUrl = _ref.blobUrl;

    Object.assign(_this.recordedTranslations, (0, _defineProperty3.default)({}, language, blobUrl));
  };

  this.getRecordedTranslation = function (_ref2) {
    var language = _ref2.language;
    return _this.recordedTranslations[language] || "";
  };

  this.getAttachments = function () {
    return _Attachment2.default.getAttachments(_this.api, _this.id);
  };

  this.newAttachment = function (data) {
    return _Attachment2.default.newAttachment(_this.api, _this.id, data);
  };

  this.getAttachment = function (id) {
    return _Attachment2.default.getAttachment(_this.api, _this.id, id);
  };

  this.deleteAttachment = function (id) {
    return _Attachment2.default.deleteAttachment(_this.api, _this.id, id);
  };
};

exports.default = Phrase;


//////////////////
// WEBPACK FOOTER
// ../sdk/lib/Phrase.js
// module id = 316
// module chunks = 0